var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("客服管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pageTab" }, [
          _c("div", { staticClass: "boxContent" }, [
            _c(
              "div",
              { staticStyle: { width: "80%", border: "1px solid #ccc" } },
              [
                _c(
                  "div",
                  {
                    ref: "mianscroll",
                    class: [
                      "chat",
                      _vm.username == "kefu11" || _vm.username == "kefu99"
                        ? ""
                        : "noSend",
                    ],
                    attrs: { id: "msgBody" },
                    on: { scroll: _vm.handleScroll },
                  },
                  _vm._l(_vm.messageList, function (item, index) {
                    return _c("div", { key: index }, [
                      item.from != _vm.user
                        ? _c("div", { staticClass: "chatItem" }, [
                            _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "chatImg" }, [
                                _c("img", {
                                  attrs: {
                                    src:
                                      _vm.selectUserData.avatar ||
                                      require("@/assets/imgs/headImg.png"),
                                    alt: "",
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _vm.selectUserData.name &&
                                  _vm.selectUserData.name != "" &&
                                  _vm.selectUserData.name != null
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.selectUserData.name) +
                                            "\n                    "
                                        ),
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("phone")(
                                              _vm.selectUserData.phone
                                            )
                                          )
                                        ),
                                      ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [_vm._v(_vm._s(item.time))]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userchat" }, [
                              item.info.type == 0
                                ? _c("div", { staticClass: "box-card" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "box-card",
                                      staticStyle: { background: "#fff" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePictureCardPreview(
                                            item.info.context
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: item.info.context,
                                          alt: "",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 2
                                ? _c("div", { staticClass: "box-card" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 3
                                ? _c("div", { staticClass: "box-card" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 4
                                ? _c("div", { staticClass: "box-card" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 5
                                ? _c("div", { staticClass: "box-card" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 6
                                ? _c("div", { staticClass: "box-card" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.address) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 7
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.goJob(item.info.id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card1" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardTop" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          任务编号：" +
                                                      _vm._s(item.info.jobNo) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardStatus" },
                                                [
                                                  item.info.status == 0
                                                    ? _c("span", [
                                                        _vm._v("待支付"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 1
                                                    ? _c("span", [
                                                        _vm._v("待发布"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 2
                                                    ? _c("span", [
                                                        _vm._v("发布中"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 3
                                                    ? _c("span", [
                                                        _vm._v("已收单"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 4
                                                    ? _c("span", [
                                                        _vm._v("实做中"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 5
                                                    ? _c("span", [
                                                        _vm._v("已取消"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 6
                                                    ? _c("span", [
                                                        _vm._v("已结算"),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        任务名称：" +
                                                  _vm._s(item.info.jobName) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        地址：" +
                                                  _vm._s(item.info.address) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        时间：" +
                                                  _vm._s(item.info.jobStart) +
                                                  "-" +
                                                  _vm._s(item.info.jobEnd) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 8
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.gocomplaint(
                                            item.info.jobComplainId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card1" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardTop" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          投诉编号：" +
                                                      _vm._s(
                                                        item.info.complainNo
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardStatus" },
                                                [
                                                  item.info.jobComplainStatus ==
                                                  0
                                                    ? _c("span", [
                                                        _vm._v("未处理"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.jobComplainStatus ==
                                                  1
                                                    ? _c("span", [
                                                        _vm._v("已处理"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.jobComplainStatus ==
                                                  2
                                                    ? _c("span", [
                                                        _vm._v("已撤销"),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        任务名称：" +
                                                  _vm._s(item.info.jobName) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        被投诉人名称：" +
                                                  _vm._s(
                                                    item.info.respondentName
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        投诉人名称：" +
                                                  _vm._s(
                                                    item.info.complainantName
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        投诉原因：" +
                                                  _vm._s(
                                                    item.info.complainMemo
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cardTop",
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          提交时间：" +
                                                      _vm._s(
                                                        item.info.submitAt
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          责任人类型：" +
                                                      _vm._s(
                                                        item.info.dutyType == 1
                                                          ? "用户"
                                                          : item.info
                                                              .dutyType == 2
                                                          ? "保安(临勤)"
                                                          : "保安(公司)"
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 9
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.godefault(
                                            item.info.violateLogId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card1" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardTop" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          违约编号：" +
                                                      _vm._s(
                                                        item.info.violateLogNo
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardStatus" },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        item.info
                                                          .violateLogStatus == 0
                                                          ? "待支付"
                                                          : "已支付"
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        任务名称：" +
                                                  _vm._s(item.info.jobName) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        违约类型：" +
                                                  _vm._s(
                                                    item.info.voilateTypeTitle
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        违约规则：" +
                                                  _vm._s(item.info.matterMemo) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cardTop",
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          违约：￥" +
                                                      _vm._s(
                                                        item.info.violateAmount
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          退还：￥" +
                                                      _vm._s(
                                                        item.info.refundAmount
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 10
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.goappeal(
                                            item.info.appealId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card1" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardTop" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          考勤申诉编号：" +
                                                      _vm._s(
                                                        item.info.appealNo
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardStatus" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.info
                                                          .operateStatusTitle
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        任务名称：" +
                                                  _vm._s(item.info.jobName) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        考勤日期：" +
                                                  _vm._s(item.info.dueAtIn) +
                                                  "-" +
                                                  _vm._s(item.info.dueAtOut) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        打卡状态：" +
                                                  _vm._s(
                                                    item.info.signStatusTitle
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        申诉原因：" +
                                                  _vm._s(
                                                    item.info.appealReason
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : _c("div", { staticClass: "chatItem" }, [
                            _c("div", { staticClass: "userInfo1" }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-right": "10px",
                                    "text-align": "right",
                                  },
                                },
                                [
                                  _c("div", [_vm._v(_vm._s(item.from))]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [_vm._v(_vm._s(item.time))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(0, true),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userchat1" }, [
                              item.info.type == 0
                                ? _c("div", { staticClass: "box-card other" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "box-card other",
                                      staticStyle: { background: "#fff" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePictureCardPreview(
                                            item.info.context
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: item.info.context,
                                          alt: "",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 2
                                ? _c("div", { staticClass: "box-card other" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 3
                                ? _c("div", { staticClass: "box-card other" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 4
                                ? _c("div", { staticClass: "box-card other" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 5
                                ? _c("div", { staticClass: "box-card other" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.context) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 6
                                ? _c("div", { staticClass: "box-card other" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.info.address) +
                                        "\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 7
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.goJob(item.info.id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card1 other" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardTop" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          任务编号：" +
                                                      _vm._s(item.info.jobNo) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardStatus" },
                                                [
                                                  item.info.status == 0
                                                    ? _c("span", [
                                                        _vm._v("待支付"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 1
                                                    ? _c("span", [
                                                        _vm._v("待发布"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 2
                                                    ? _c("span", [
                                                        _vm._v("发布中"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 3
                                                    ? _c("span", [
                                                        _vm._v("已收单"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 4
                                                    ? _c("span", [
                                                        _vm._v("实做中"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 5
                                                    ? _c("span", [
                                                        _vm._v("已取消"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.status == 6
                                                    ? _c("span", [
                                                        _vm._v("已结算"),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        任务名称：" +
                                                  _vm._s(item.info.jobName) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        地址：" +
                                                  _vm._s(item.info.address) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        时间：" +
                                                  _vm._s(item.info.jobStart) +
                                                  "-" +
                                                  _vm._s(item.info.jobEnd) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cardTop",
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          单价：￥" +
                                                      _vm._s(
                                                        item.info.unitPrice
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          任务时长：" +
                                                      _vm._s(
                                                        _vm._f("maxTime")(
                                                          item.info.hour * 60
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          总金额：￥" +
                                                      _vm._s(item.info.price) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 8
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.gocomplaint(
                                            item.info.jobComplainId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card1 other" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardTop" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          投诉编号：" +
                                                      _vm._s(
                                                        item.info.complainNo
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardStatus" },
                                                [
                                                  item.info.jobComplainStatus ==
                                                  0
                                                    ? _c("span", [
                                                        _vm._v("未处理"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.jobComplainStatus ==
                                                  1
                                                    ? _c("span", [
                                                        _vm._v("已处理"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.info.jobComplainStatus ==
                                                  2
                                                    ? _c("span", [
                                                        _vm._v("已撤销"),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        任务名称：" +
                                                  _vm._s(item.info.jobName) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        被投诉人名称：" +
                                                  _vm._s(
                                                    item.info.respondentName
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        投诉人名称：" +
                                                  _vm._s(
                                                    item.info.complainantName
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        投诉原因：" +
                                                  _vm._s(
                                                    item.info.complainMemo
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cardTop",
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          提交时间：" +
                                                      _vm._s(
                                                        item.info.submitAt
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          责任人类型：" +
                                                      _vm._s(
                                                        item.info.dutyType == 1
                                                          ? "用户"
                                                          : item.info
                                                              .dutyType == 2
                                                          ? "保安(临勤)"
                                                          : "保安(公司)"
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 9
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.godefault(
                                            item.info.violateLogId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card1 other" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardTop" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          违约编号：" +
                                                      _vm._s(
                                                        item.info.violateLogNo
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardStatus" },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        item.info
                                                          .violateLogStatus == 0
                                                          ? "待支付"
                                                          : "已支付"
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        任务名称：" +
                                                  _vm._s(item.info.jobName) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        违约类型：" +
                                                  _vm._s(
                                                    item.info.voilateTypeTitle
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        违约规则：" +
                                                  _vm._s(
                                                    item.info.voilateMemo
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cardTop",
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          违约：￥" +
                                                      _vm._s(
                                                        item.info.violateAmount
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          退还：￥" +
                                                      _vm._s(
                                                        item.info
                                                          .refundAmount || 0
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.info.type == 10
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.goappeal(
                                            item.info.appealId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card1 other" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardTop" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cardNum" },
                                                [
                                                  _vm._v(
                                                    "\n                          考勤申诉编号：" +
                                                      _vm._s(
                                                        item.info.appealNo
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cardStatus" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.info
                                                          .operateStatusTitle
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        任务名称：" +
                                                  _vm._s(item.info.jobName) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        考勤日期：" +
                                                  _vm._s(item.info.dueAtIn) +
                                                  "-" +
                                                  _vm._s(item.info.dueAtOut) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        打卡状态：" +
                                                  _vm._s(
                                                    item.info.signStatusTitle
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        申诉原因：" +
                                                  _vm._s(
                                                    item.info.appealReason
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm.username == "kefu11" || _vm.username == "kefu99"
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      color: "blue",
                                      "margin-right": "60px",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.backInfo(item, index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  撤回\n                "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.username == "kefu11" || _vm.username == "kefu99"
                  ? _c(
                      "div",
                      { staticClass: "send", attrs: { id: "msgFooter" } },
                      [
                        _vm.sendImg == ""
                          ? _c("el-input", {
                              staticStyle: { "margin-right": "auto" },
                              attrs: {
                                type: "textarea",
                                rows: 5,
                                placeholder: "请输入内容",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.sendMessage()
                                },
                              },
                              model: {
                                value: _vm.inputMessage,
                                callback: function ($$v) {
                                  _vm.inputMessage = $$v
                                },
                                expression: "inputMessage",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.sendImg
                          ? _c("img", {
                              staticClass: "avatar",
                              staticStyle: { "margin-right": "auto" },
                              attrs: { src: _vm.sendImg },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-upload",
                          {
                            staticClass: "avatar-uploader",
                            attrs: {
                              action: _vm.uploadUrl,
                              headers: _vm.deader,
                              "show-file-list": false,
                              "on-success": _vm.handleAvatarSuccess,
                            },
                          },
                          [
                            _c("div", { staticClass: "btn" }, [
                              _vm._v("\n                图片"),
                              _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.sendMessage()
                              },
                            },
                          },
                          [_vm._v("发送")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "infinite-scroll",
                    rawName: "v-infinite-scroll",
                    value: _vm.loadUser,
                    expression: "loadUser",
                  },
                ],
                staticStyle: {
                  width: "20%",
                  "overflow-y": "scroll",
                  "min-height": "100%",
                  "max-height": "78vh",
                },
              },
              [
                _c("div", { staticClass: "listTile" }, [_vm._v("用户列表")]),
                _vm._v(" "),
                _vm._l(_vm.userList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: [
                        "userItem",
                        _vm.selectUserData.memberId == item.memberId
                          ? "ueserSelect"
                          : "",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.selectUser(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "userImg" }, [
                        _c("img", {
                          attrs: {
                            src:
                              item.avatar ||
                              require("@/assets/imgs/headImg.png"),
                            alt: "",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { margin: "0 10px" } }, [
                        item.name && item.name != "" && item.name != null
                          ? _c("div", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.name) +
                                  "\n              "
                              ),
                            ])
                          : _c("div", [
                              _vm._v(_vm._s(_vm._f("phone")(item.phone))),
                            ]),
                        _vm._v(" "),
                        item.memberType == 1
                          ? _c("div", [_vm._v("客户")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.memberType == 2
                          ? _c("div", [_vm._v("临勤")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.memberType == 3
                          ? _c("div", [_vm._v("保安公司")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.memberType == 4
                          ? _c("div", [_vm._v("保安公司员工")])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      item.unReadNum > 0
                        ? _c("div", { staticClass: "num" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  item.unReadNum > 99 ? "99+" : item.unReadNum
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chatImg" }, [
      _c("img", {
        attrs: { src: require("../../assets/imgs/kefu.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }